import React from "react";
import {
  // useEditController,
  Edit,
  TopToolbar,
  SimpleForm,
  TextInput,
  DateField,
  RadioButtonGroupInput,
} from "react-admin";

import { Grid } from "@material-ui/core";

import { BackButton } from "../../../components/common/BackButton";
import { LogStatuses } from "../../../utils/constants";
import { TenantInput } from "./TenantField";

const LogShowActions = ({ basePath }) => (
  <TopToolbar>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

export const LogEdit = (props) => {
  return (
    <Edit
      {...props}
      title="Log Edit"
      mutationMode="pessimistic"
      actions={<LogShowActions />}
    >
      <SimpleForm variant="outlined" submitOnEnter={false}>
        <Grid container direction="column" spacing={1} fullWidth>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12} md={6}>
              <DateField
                source="createdAt"
                label="Created At"
                fullWidth
                showTime={true}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextInput
                source="appType"
                label="App Type"
                variant="outlined"
                fullWidth
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12} md={6}>
              <TenantInput label="Tenant" fullWidth />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextInput
                source="user"
                label="User"
                variant="outlined"
                fullWidth
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12}>
              <TextInput
                source="message"
                label="Message"
                variant="outlined"
                fullWidth
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12}>
              <TextInput
                source="url"
                label="URL"
                variant="outlined"
                fullWidth
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12}>
              <TextInput
                source="exception"
                label="Exception"
                variant="outlined"
                fullWidth
                multiline
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={6}>
              <TextInput
                source="appVersion"
                label="App Version"
                variant="outlined"
                fullWidth
                disabled={true}
              />
            </Grid>
            <Grid item xs={12}>
              <TextInput
                source="context"
                label="Context"
                variant="outlined"
                fullWidth
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12}>
              <RadioButtonGroupInput
                source="status"
                label="Status"
                variant="outlined"
                choices={LogStatuses}
              />
            </Grid>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
